import { useGetList } from 'react-admin';
import type { MissionType } from '@wwf/sdk';

export const useMissionTypes = (options?: { enabled?: boolean }) => {
    return useGetList<MissionType>('missionType', {
        pagination: { page: 0, perPage: 200 },
        sort: { field: 'name', order: 'ASC' },
        filter: { enabled: options?.enabled ?? true },
    });
};
